require('normalize.css/normalize.css');
require('styles/App.css');
import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Event from './Event';
import EventInvite from './EventInvite';
import 'react-datepicker/dist/react-datepicker.css';

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

export default class Schedule extends React.Component {
 constructor (props) {
	

    super(props)
    this.state = {
      startDate: moment(),
	  startEvent: <Event />,
	  MInput: <EventInvite />
	};
    this.handleChange = this.handleChange.bind(this);
  }
  handleSelect(date) {
    this.setState({
      startDate: date
    });
  }
  handleChange (date) {
  this.setState({startDate: date})
  this.toggleCalendar()
}

toggleCalendar (e) {
  e && e.preventDefault()
  this.setState({isOpen: this.state.isOpen})
}
  onClick () {
  this.setState({startEvent: this.state.MInput})
}


  render() {
    return (
	
 <div className="calendar"><DatePicker
    inline
    selected={this.state.startDate}
	onChange={this.handleChange}
	onClick={this.onClick}><div style={{color: 'red'}}>
    <a href="http://www.hidmet.gov.rs/ciril/prognoza/index.php">Vremmmenska prognoza!</a>
  </div>
</DatePicker> 
<div></div></div>);
  }
}


// WEBPACK FOOTER //
// ./src/components/Schedule.js